<template>
  <div id="trendDetail">
    <bread :content="breadContent"></bread>
    <p class="Page-title">研究动态</p>
    <el-divider></el-divider>
    <div id="content">
      <blockTime :year="time.year" :month="time.month" :day="time.day"></blockTime>
      <div class="body">
        <Article :margin="'20px 10% 0 0'" :title="detailData.Title" :subTitle="detailData.SubTitle" :authors="detailData.Author" :html="detailData.Content"></Article>
        <about-link v-if="detailData.Links" :Links="detailData.Links"></about-link>
      </div>
      <timeline :list="timelineData.list" :iconSrc="timelineData.iconSrc" :title="'最新热点'" :titleColor="'red'"></timeline>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import blockTime from "@/components/blockTime";
import timeline from "@/components/timeline";
import aboutLink from "@/components/link";
import Api from "@/network.js";
import utils from "@/utils.js";
import Article from "@/components/article";
export default {
  name: "trendDetail",
  components: {
    bread,
    timeline,
    blockTime,
    aboutLink,
    Article
  },
  async beforeRouteEnter(to, from, next) {
    const data = {};
    data.detailData = await Api.academic.getTrendsDetail(to.query.id);
    data.time = utils.timeResult(data.detailData.AdminSetTime);
    const resTimeData = await Api.index.getLast("yjdt");
    const list = resTimeData.map(item => ({
      date: item.Date,
      content: item.Title,
      url: `/academic/trends/detail?id=${encodeURIComponent(item.Id)}`
    }));
    next(vm => {
      vm.setData(data, list);
      // 指定高亮菜单栏文字
      vm.$store.commit("setHighlightText", "研究动态");
    });
  },
  watch: {
    $route() {
      this.$router.go(0);
    }
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "学术交流", routerName: "academic" },
        { text: "研究动态", routerName: "opinion" }
      ],
      detailData: {},
      time: {},
      timelineData: {
        title: "最新热点",
        iconSrc: require("../../assets/fire-icon.png"),
        list: []
      }
    };
  },
  methods: {
    async getData() {
      let resTimeData = await Api.index.getLast("yjdt");
      this.detailData = await Api.academic.getTrendsDetail(
        this.$route.query.id
      );
      this.timelineData.list = resTimeData.map(item => ({
        date: item.Date,
        content: item.Title,
        url: `/academic/trends/detail?id=${encodeURIComponent(item.Id)}`
      }));
      this.time = this.$utils.timeResult(this.detailData.AdminSetTime);
    },
    setData(data, list) {
      Object.assign(this.$data, data);
      this.timelineData.list = list;
    }
  },
  // 离开详情页时清除侧边栏高亮项，防止冲突
  destroyed() {
    this.$store.commit("setHighlightText", "");
  }
};
</script>
  
<style lang="scss" scoped>
#trendDetail {
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}

#content {
  display: flex;
  position: relative;
  justify-content: space-between;
  .blockTime {
    position: absolute;
    left: 0;
    top: -10px;
  }
  .link {
    margin-top: 80px;
  }
  .body {
    width: calc(100% - 250px);
  }
}
</style>

